module.exports = __webpack_public_path__ + "img/server-01.5288ae52.svg";